import {lazy} from "react";

export const TrackAdvancedLazy = lazy(()=>import('./TrackAdvanced'))